// extracted by mini-css-extract-plugin
export default {"root":"ClaimsForm-root_botg5"};